/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Status from 'galax/server/status';


export default class extends Status
{
  isProduction ()
  {
    return this.isType('create');
  }


  isAttack ()
  {
    return this.isType('attack');
  }


  isDock ()
  {
    return this.isType('dock');
  }


  isMove ()
  {
    return this.isType('move');
  }


}
